module.exports = __webpack_public_path__ + "img/store.7c8ff8f0.png";